import {
  DashboardSubpageDocumentsEntityType,
  DashboardSubpageDocumentsSourceType,
} from '../../../screens/Dashboard/subpages/DashboardSubpageDocuments/DashboardSubpageDocuments';
import { GetStipulationDocumentsResponse } from '../../../types/dashboardDocuments';
import { axiosWithToken } from '../index';
import { GetLeasingDocumentFileResponse, GetLeasingDocumentsResponse } from './types';

const { REACT_APP_API_GATEWAY, REACT_APP_BACKEND_BRAND } = process.env;

export const getLeasingDocumentsList = async (
  id: string,
  sourceType: DashboardSubpageDocumentsSourceType,
  entityType: DashboardSubpageDocumentsEntityType
): Promise<GetLeasingDocumentsResponse> => {
  const url = `${REACT_APP_API_GATEWAY}/${REACT_APP_BACKEND_BRAND}/central-document-page/leasing-documents?id=${id}&sourceType=${sourceType}&entityType=${entityType}`;
  return axiosWithToken
    .get(url)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export const getLeasingDocumentFileLink = async (
  id: string,
  documentId: string,
  transactionId: string,
  sourceType: DashboardSubpageDocumentsSourceType,
  entityType: DashboardSubpageDocumentsEntityType
): Promise<GetLeasingDocumentFileResponse> => {
  const url = `${REACT_APP_API_GATEWAY}/${REACT_APP_BACKEND_BRAND}/central-document-page/leasing-documents/${documentId}?id=${id}&sourceType=${sourceType}&entityType=${entityType}&transactionId=${transactionId}`;
  return axiosWithToken
    .get(url)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export const getCentralDocumentHandlerStipulationDocuments = async (
  id: string,
  sourceType: DashboardSubpageDocumentsSourceType,
  entityType: DashboardSubpageDocumentsEntityType
): Promise<GetStipulationDocumentsResponse> => {
  const url = `${REACT_APP_API_GATEWAY}/${REACT_APP_BACKEND_BRAND}/central-document-page/stipulations?id=${id}&sourceType=${sourceType}&entityType=${entityType}`;
  return axiosWithToken
    .get<GetStipulationDocumentsResponse>(url)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export const postCentralDocumentHandlerStipulationDocument = async (
  id: string,
  stipulationId: string,
  sourceType: DashboardSubpageDocumentsSourceType,
  entityType: DashboardSubpageDocumentsEntityType,
  payload: Pick<MediaStorageService.Schemas.FilesResponse['file'], 'id' | 'mimeType'>,
  creditCoApplicantId?: string
): Promise<any> => {
  let url = `${REACT_APP_API_GATEWAY}/${REACT_APP_BACKEND_BRAND}/central-document-page/stipulations/${stipulationId}/documents?id=${id}&sourceType=${sourceType}&entityType=${entityType}`;
  if (creditCoApplicantId) {
    url += `&creditCoApplicantId=${creditCoApplicantId}`;
  }
  return axiosWithToken
    .post(url, payload)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export const getCentralDocumentHandlerStipulationDocument = async (
  id: string,
  stipulationId: string,
  documentId: string,
  sourceType: DashboardSubpageDocumentsSourceType,
  entityType: DashboardSubpageDocumentsEntityType,
  creditCoApplicantId?: string
): Promise<any> => {
  let url = `${REACT_APP_API_GATEWAY}/${REACT_APP_BACKEND_BRAND}/central-document-page/stipulations/${stipulationId}/documents/${documentId}?id=${id}&sourceType=${sourceType}&entityType=${entityType}`;
  if (creditCoApplicantId) {
    url += `&creditCoApplicantId=${creditCoApplicantId}`;
  }
  return axiosWithToken
    .get(url)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export const deleteCentralDocumentHandlerStipulationDocument = async (
  id: string,
  stipulationId: string,
  documentId: string,
  sourceType: DashboardSubpageDocumentsSourceType,
  entityType: DashboardSubpageDocumentsEntityType,
  creditCoApplicantId?: string
): Promise<any> => {
  let url = `${REACT_APP_API_GATEWAY}/${REACT_APP_BACKEND_BRAND}/central-document-page/stipulations/${stipulationId}/documents/${documentId}?id=${id}&sourceType=${sourceType}&entityType=${entityType}`;
  if (creditCoApplicantId) {
    url += `&creditCoApplicantId=${creditCoApplicantId}`;
  }
  return axiosWithToken
    .delete(url)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};
